import styled from '@emotion/styled'

const BottomShade = styled.div`
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	height: 50px;
	pointer-events: none;
	background: linear-gradient(180deg, rgba(250, 250, 250, 0) 0%, rgba(250, 250, 250, 0.8) 100%);
`

export default BottomShade
